export default "__VITE_ASSET__CMb0f67E__"